import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface FilterState {
  activeFilters: { [key: string]: any };
}

const initialState: FilterState = {
  activeFilters: {},
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<{ [key: string]: any }>) {
      state.activeFilters = action.payload;
    },
    clearFilters(state) {
      state.activeFilters = {};
    },
  },
});
export const selectActiveFilters = (state: { filters: FilterState }) => state.filters.activeFilters;
export const { setFilters, clearFilters } = filterSlice.actions;
export default filterSlice.reducer;
